'use client';

import FacebookIcon from './Facebook.js';
import LinkedinIcon from './Linkedin.js';
import TwitterIcon from './Twitter.js';
import ZaloIcon from './Zalo.js';
import FacebookIconColorFull from './FacebooksColorFull.js';
import LinkedinIconColorFull from './LinkedinColorFull.js';
import TwitterIconColorFull from './TwitterColorFull.js';
import ZaloIconColorFull from './ZaloColorFull.js';
import ShareIcon from './Share.js';

var SocialMedia = {
    FacebookIconColorFull: FacebookIconColorFull,
    LinkedinIconColorFull: LinkedinIconColorFull,
    TwitterIconColorFull: TwitterIconColorFull,
    ZaloIconColorFull: ZaloIconColorFull,
    FacebookIcon: FacebookIcon,
    LinkedinIcon: LinkedinIcon,
    TwitterIcon: TwitterIcon,
    ZaloIcon: ZaloIcon,
    ShareIcon: ShareIcon
};

export { SocialMedia as default };
//# sourceMappingURL=index.js.map
